module.exports = __webpack_public_path__ + "static/media/layersIcon.b4cc5781.svg";